import { DatasetType } from '../models/dataset-type';
import { IFilters } from '../models/filters';
import { IPlotRange } from '../models/range';

/**
 * add either a time or number range constraint based on the range model provided
 * @param range The range to request data for
 * @param rangeName The name of the range. For example, 'time' or 'wavelength'
 */
export function addRangeConstraint( range: IPlotRange, offset = 0, rangeName: string = 'time' ) {
    if ( range.isDate ) {
        return '&' + rangeName
                   + '>=' + new Date( range.start + offset ).toISOString() + '&' + rangeName
                   + '<=' + new Date( range.end + offset ).toISOString();
    } else {
        return '&' + rangeName + '>=' + ( range.start + offset ) + '&' + rangeName + '<=' + ( range.end + offset );
    }
}

/**
 * add filter constraints
 * @param type The type of dataset being accessed. Determines which kinds of filters can be added
 * @param filters The filters to add to the access URL
 */
export function addFilters( type: DatasetType, filters: IFilters, xName?: string ) {
    let query = '';
    xName = xName ? xName : 'value';
    if ( type === DatasetType.analog ) {
        // minmax filter
        if ( filters.minmax.enabled ) {
            query += '&' + xName + '>' + filters.minmax.min;
            query += '&' + xName + '<' + filters.minmax.max;
        }

        // delta filter
        if ( filters.delta.enabled ) {
            query += '&maxDelta(' + xName + ',' + filters.delta.value + ')';
        }
    }

    // change filter
    if ( filters.change.enabled ) {
        query += '&thin()';
    }
    return query;
}

/**
 * Add bin average and exclude missing constraints if required. TODO: make this more general
 * @param type The dataset type. Discrete and event table datasets do not get these extra parameters
 * @param numBins The maximum number of points latis should return. Makes our chart more performant and downloads faster
 */
export function addExtraAccessParameters( type: DatasetType, numBins: number ) {
    if ( type === DatasetType.analog && numBins ) {
        return '&binave(' + numBins + ')&exclude_missing()';
    }
    return '';
}
